import { render } from "./SubmitClaimRequest.vue?vue&type=template&id=f247ebb6"
import script from "./SubmitClaimRequest.vue?vue&type=script&lang=js"
export * from "./SubmitClaimRequest.vue?vue&type=script&lang=js"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__